const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  NATURE: 'NATURE',
};

const DAYS_OF_WEEK = [
  { value: '1', label: 'Saturday' },
  { value: '2', label: 'Sunday' },
  { value: '3', label: 'Monday' },
  { value: '4', label: 'Tuesday' },
  { value: '5', label: 'Wednesday' },
  { value: '6', label: 'Thursday' },
  { value: '7', label: 'Friday' },
];

const WORKING_TIME = [
  { value: 'day', label: 'Day - 04:00 AM' },
  { value: 'noon', label: 'Noon - 08:00 AM' },
  { value: 'night', label: 'Night - 12:00 AM' },
  { value: 'all', label: 'All' },
];

export { DAYS_OF_WEEK, THEMES, WORKING_TIME };
